import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Global } from 'src/app/global/globalApi';
import { LoginDTO } from 'src/app/models/LoginDTO';
import { ApiService } from 'src/app/services/api.service';
import { NewAgentApiService } from 'src/app/services/new-agent-api.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { environment } from 'src/environments/environment';
import * as Constants from '../../models/Constants';
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginFormObj = new LoginDTO();
  iconConfigEye = {
    iconName: 'eye',
    iconType: 'fal',
  };
  iconConfigEyeSlash = {
    iconName: 'eye-slash',
    iconType: 'fal',
  };
  hidePwdIcon = true;
  inputDataType: string = '';
  disableLoginButton: boolean = false;
  accountNotBlocked: boolean = true;

  loginForm = new FormGroup({
    lanId: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });
  loadLoginPage: boolean = true;

  constructor(
    private router: Router,
    private apiService: NewAgentApiService,
    private route: ActivatedRoute,
    public rootScope: RootScopeService,
    public loginService: ApiService,
    private encrytDecryptService: EncryptDecryptService,
    private http: HttpClient
  ) {

    let that = this;
    this.inputDataType= atob(Constants.DATA_TYPE.pinputType);
    this.route.queryParams
      .subscribe(params => {
        console.log(params);
        this.rootScope.oldSessionId = params['oldSessionId'];
        this.rootScope.newSessionId = params['newSessionId'];
         /* istanbul ignore next */
        if (params.hasOwnProperty('oldSessionId') && params.hasOwnProperty('newSessionId')) {
          localStorage.setItem('sessionId', this.rootScope.oldSessionId);
          sessionStorage.setItem('sessionId', this.rootScope.oldSessionId);
          that.rootScope.isSSODuplicate = true;
        }
      }
      );
  }

  ngOnInit(): void {
    this.loadApplicationBySSO();
  }

  /****
   * We have below 4 ways to launch our application
   * Case 1 :  SSO
   * Case 2 : Manual login
   * Case 3 & 4 : bookmark or right click and open duplicate tab
   *
   * @author :Pooja Gupta
   * 
   * Below method deals with LAUNCHING APP VIA SSO.
   * 
   * When application is launched successfully below url will be sent by backend:
   * http://localhost:4200/home/sso/16112E53F4CC4D46EB0600CF7994BBB4/pooja.gupta2@alight.com/
   * 
   * When SSO fails:
   * http://localhost:4200/ssoerror
   * 
   * When while launching app vis SSO ,backend figures out its a duplicate request
   * http://localhost:4200/home/sso/ValidateSession?oldSessionId=CA696B9085C132E6055FE7F71EA22369&newSessionId=3834E0F17E80D76F1579B90513C2A6E9
   */

  loadApplicationBySSO() {
 /* istanbul ignore next */
    if (this.route.snapshot.params['sessionId']) {
      this.loadLoginPage = false;
      // console.log('Method loadApplication called', this.route.snapshot.params);
      let urlpath = this.route.snapshot.params['sessionId'] + '/' + this.route.snapshot.params['emailId'];
      this.apiService
        .getApi(Global.ssoLogin.testApi + urlpath, null, 'flase', false)
        .subscribe({
          next: (res) => {
            if (res && res?.data?.statusCode <= 399) {
              this.rootScope.launchAppBySSO = true;
              this.rootScope.sessionId = this.route.snapshot.params['sessionId'];
              this.rootScope.emailId = this.route.snapshot.params['emailId'];
              localStorage.setItem('sessionId', this.route.snapshot.params['sessionId']);
              localStorage.setItem('emailId', this.route.snapshot.params['emailId']);
              sessionStorage.setItem("sessionId", this.route.snapshot.params['sessionId']);
              sessionStorage.setItem("browserSessionStartTimestamp", res.data['browserSessionStartTimestamp']);
              this.rootScope._isAuthenticated.next(true);
              this.loginService.getUserDetails()

            } else {
              this.rootScope._isLogout.next(true);
              // this.rootScope.enableAlerts(Constants.ERROR, Constants.errorObj.ssoError);
              // this.rootScope.ssoError=Constants.errorObj.ssoError;
              /****SSO Failing redirecting to login page *****/
              this.router.navigate(['/ssoerror']);
            }
          },
          error: (error) => {
            // this.rootScope.enableAlerts(Constants.ERROR, Constants.errorObj.ssoError);
            // this.rootScope.ssoError=Constants.errorObj.ssoError;
            this.rootScope._isLogout.next(true);
            /****SSO Failing redirecting to login page *****/
            this.router.navigate(['/ssoerror']);
          },
        });
    }
    else if (this.rootScope.isSSODuplicate) {
      this.router.navigate(['/'])
    }

  }



  /**Below method handle the toggle of UI password eye/eye-slash on click of the icon */
 
  togglePwdIcon() {
    this.hidePwdIcon = !this.hidePwdIcon;
    this.hidePwdIcon
      ? (this.inputDataType = atob(Constants.DATA_TYPE.pinputType))
      : (this.inputDataType = Constants.DATA_TYPE.text);
  }

  /**Below method handle the Submit button click event of User Registration Form */
 
  onSubmit() {
    // console.log('Method onSubmit called ', this.loginForm.invalid);
    if (!this.loginForm.invalid) {
      this.login();
    } else {
    }
  }

  
  login() {
    this.rootScope.loginAccountUnauthorizedError = false;
    this.rootScope.loginAccountBlockedError = false;
    this.rootScope.loginAccountUnexpectedError = false;
    this.accountNotBlocked = true;
    // console.log('Method login called');
    this.loginFormObj.lanId = this.encrytDecryptService.encrypt(this.loginForm.value.lanId);
    this.loginFormObj.password = this.encrytDecryptService.encrypt(this.loginForm.value.password);
   /* istanbul ignore next */
    this.loginService.login(this.loginFormObj).subscribe({
      next: (data: any) => {
     
        console.log('res', data);
        if (data?.httpStatusCode == 200) {
          let res = data?.data;
          this.rootScope.isDuplicateSession = res?.isDuplicate;
          this.rootScope.sessionId = res?.jsessionId;
          this.rootScope.emailId = res?.emailId;
          this.rootScope.launchAppFromManualLogin = true;
          this.rootScope.browserSessionStartTimestamp = res?.browserSessionStartTimestamp;
          this.rootScope._isAuthenticated.next(true);
          this.loginService.getUserDetails();
          if (this.rootScope.createNameForUserProfile(res?.firstName, res?.lastName, res?.lanId, res?.browserSessionStartTimestamp))
            this.router.navigate(['/']);
        }

      },
      error: (error: any) => {
        if (
          error?.error?.httpStatusCode == 401 &&
          error?.error?.httpStatus == 'UNAUTHORIZED'
        ) {
          this.rootScope.loginAccountUnauthorizedError = true;
          this.rootScope.loginAccountBlockedError = false;
          this.rootScope.loginAccountUnexpectedError = false;
        } else if (
          error?.error?.httpStatusCode == 423 &&
          error?.error?.httpStatus == 'LOCKED'
        ) {
          this.rootScope.loginAccountUnauthorizedError = false;
          this.rootScope.loginAccountBlockedError = true;
          this.rootScope.loginAccountUnexpectedError = false;
          this.accountNotBlocked = false;
          this.loginForm.reset();
          this.disableLoginButton = true;
          this.loginForm.disable();
        } else {
          this.rootScope.loginAccountUnauthorizedError = false;
          this.rootScope.loginAccountUnauthorizedError = false;
          this.rootScope.loginAccountUnexpectedError = true;
        }
      },
    });
  }
}
